import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from "@nu-art/permissions-shared";
export const PermissionDomainName_Avatar = 'Avatar Mode UI';
export const PermissionKeys_Avatar = generateKeyNamesByAccessLevel(PermissionDomainName_Avatar, defaultUIAccessLevels);
//# sourceMappingURL=avatar-ui.js.map